/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import {createRouter, createWebHistory, isNavigationFailure} from "vue-router";
import paths from './paths';

function route(path, view, name, children = [], alias = null) {
    let generatedRoute = {
        path
    };
    if (!!view) {
        generatedRoute['name'] = name;
        generatedRoute['component'] = (resovle) => import(
            `../pages/${view}.vue`
            ).then(resovle);
    } else {
        generatedRoute['redirect'] = name;
    }
    if (!!alias) {
        generatedRoute['alias'] = alias;
    }
    if (!!children && children.length > 0) {
        generatedRoute['children'] = children.map(obj => {
            return route(obj.path, obj.view, obj.name, !!obj.children ? obj.children : [])
        });
    }
    return generatedRoute;
}


// let paths =  paths;
// Create a new router
const router = new createRouter({
    history: createWebHistory('/'),
    // base: window.location.pathname.split('/').slice(0, 4).join('/'),
    //relative: true,
    routes: paths.map(path => route(path.path, path.view, path.name || path.redirect, !!path.children ? path.children : [], path.alias)).concat([]),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        if (to.hash) {
            return {selector: to.hash}
        }
        return {left: 0, top: 0}
    },
    onError(error) {
        router.go(-1);
    },
})
//
router.afterEach((to, from, failure) => {
    if (isNavigationFailure(failure)) {
        console.log('failed navigation', failure);
    }
})

router.beforeEach((to, from, next) => {
    let element = $('.addPopover');
    if(!!element.length) {
        $('.addPopover').popover('dispose')
    }
    if (to.name === 'ApplicationView' || to.name === 'ApplicationEdit') {
        next({path: to.fullPath + 'business_details/'})
    }
    // if(to.name === 'QuoteEdit' || to.name === 'QuoteView') {
    //   next({path: to.fullPath +  '/business/'})
    // }
    next();
});

export default router
